import { render } from "./FileWord.vue?vue&type=template&id=d35066c4"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/FileWord.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d35066c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d35066c4', __exports__)) {
    api.reload('d35066c4', __exports__)
  }
  
  module.hot.accept("./FileWord.vue?vue&type=template&id=d35066c4", () => {
    api.rerender('d35066c4', render)
  })

}


export default __exports__